import "./App.css";
import { useState, useEffect } from "react";
import Login from "./components/Login";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import Alert from "react-bootstrap/Alert";
import { Link, Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Home from "./components/Home";
import Converter from "./components/Converter";
import Downloader from "./components/Downloader";
import Cliper from "./components/Cliper";

function App() {
  const [login, setLogin] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showNavBar, setNavBar] = useState(false);

  const handleClose = () => setNavBar(false);
  const handleShow = () => setNavBar(true);

  const handleLogout = () => {
    setShowAlert(true);
    handleClose();
  };

  const loginResponse = (response) => {
    if (response === "Login Successful") setLogin(true);
    else setLogin(false);
  };

  const logoutPressed = async () => {
    try {
      localStorage.removeItem("esri-tile-converter-token");
      localStorage.removeItem("esri-tile-converter-username");
      localStorage.removeItem("esri-tile-converter-password");

      setLogin(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let username = localStorage.getItem("esri-tile-converter-username");
    let password = localStorage.getItem("esri-tile-converter-password");
    let token = localStorage.getItem("esri-tile-converter-token");
    if (username && password && token) setLogin(true);
    else setLogin(false);
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        {!showAlert && login && (
          <div className="App">
            <Router>
              <Navbar
                key={false}
                expand={false}
                bg="primary"
                fixed="top"
                className="bg-body-tertiary mb-3"
              >
                <Container fluid>
                  <Navbar.Brand href="">
                    Tile Converter/Downloader/Cliper
                  </Navbar.Brand>
                  <Navbar.Toggle
                    onClick={handleShow}
                    aria-controls={`offcanvasNavbar-expand-${false}`}
                  />
                  <Navbar.Offcanvas
                    show={showNavBar}
                    onHide={handleClose}
                    id={`offcanvasNavbar-expand-${false}`}
                    aria-labelledby={`offcanvasNavbarLabel-expand-${false}`}
                    placement="end"
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title
                        id={`offcanvasNavbarLabel-expand-${false}`}
                      >
                        Menu
                      </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <Nav
                        className="justify-content-end flex-grow-1 pe-3"
                        variant="pills"
                        defaultActiveKey="/"
                      >
                        <Nav.Link onClick={handleClose}>
                          <Link to="/">Home</Link>
                        </Nav.Link>
                        <Nav.Link onClick={handleClose}>
                          <Link to="/converter">Package Generator</Link>
                        </Nav.Link>
                        <Nav.Link onClick={handleClose}>
                          <Link to="/downloader">Package Downloader</Link>
                        </Nav.Link>
                        <Nav.Link onClick={handleClose}>
                          <Link to="/cliper">Package Cliper</Link>
                        </Nav.Link>
                        <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                      </Nav>
                    </Offcanvas.Body>
                  </Navbar.Offcanvas>
                </Container>
              </Navbar>
              <Switch>
                <Route path="/converter" component={Converter}></Route>
                <Route path="/downloader" component={Downloader}></Route>
                <Route path="/cliper" component={Cliper}></Route>
                <Route path="/" component={Home}></Route>
              </Switch>
            </Router>
          </div>
        )}
        {showAlert && (
          <Alert variant="success">
            <Alert.Heading>Confirm Logout</Alert.Heading>
            <p>Do you want to Logout?</p>
            <hr />
            <div className="d-flex justify-content-end">
              <Button
                onClick={() => {
                  setShowAlert(false);
                  logoutPressed();
                }}
                variant="primary"
                style={{ marginRight: 5 }}
              >
                Confirm
              </Button>
              <Button
                onClick={() => setShowAlert(false)}
                variant="danger"
                style={{ marginLeft: 5 }}
              >
                Cancel
              </Button>
            </div>
          </Alert>
        )}
        {!login && <Login onLogin={loginResponse} />}
      </header>
    </div>
  );
}

export default App;
